import { messages } from './messages';

export type Language = 'en' | 'fr';

// Only the primary browser language determines the site language. For example,
// English followed by French in the preference list still selects English.
export function detectLanguage(browser?: Pick<Navigator, 'language' | 'languages'>): Language {
  const primary = browser?.languages?.[0] || browser?.language || '';
  return /^fr(?:[-_]|$)/i.test(primary) ? 'fr' : 'en';
}

export const language = detectLanguage(typeof navigator === 'undefined' ? undefined : navigator);
export const locale = language === 'fr' ? 'fr-FR' : 'en-US';

export function t(key: keyof typeof messages): string {
  return messages[key][language];
}
